import {sinistreBDL} from '../bdl/sinistre';

export const sinistreService = () => ({...sinistreBDL()});
